angular
    .module('signalview.detector')

    // generate a String key that represents a given notification (to be used in hash key)
    .service('notificationKeyService', function () {
        return function (notification) {
            const key = notification.type;
            switch (notification.type) {
                case 'email': {
                    const cc = (notification.cc || []).slice().sort().join(',');
                    const bcc = (notification.bcc || []).slice().sort().join(',');
                    return key + '_' + notification.email + '_cc:' + cc + '_bcc:' + bcc;
                }
                case 'EmailTemplate':
                case 'emailtemplate':
                    return 'emailtemplate_' + notification.templateId;
                case 'team':
                    return key + '_' + notification.team;
                case 'slack':
                    return key + '_' + notification.credentialId + '_' + notification.channel;
                case 'victorops':
                    return key + '_' + notification.credentialId + '_' + notification.routingKey;
                case 'xmatters':
                case 'amazoneventbridge':
                case 'pagerduty':
                    return key + '_' + notification.credentialId;
                case 'opsgenie':
                    return (
                        key +
                        '_' +
                        notification.credentialId +
                        '_' +
                        (notification.responderId || notification.responderName || '')
                    );
                case 'jira': {
                    const assigneeId =
                        notification.assignee &&
                        (notification.assignee.name || notification.assignee.accountId);
                    return key + '_' + notification.credentialId + '_' + (assigneeId || '');
                }
                case 'webhook':
                    return notification.credentialId
                        ? key + '_' + notification.credentialId
                        : key + '_' + notification.url + '_' + notification.secret;
            }
        };
    });
